module.exports = "build/assets/mobileBackPapers.3bec3a8f.png";